<template>
  <div class="position-relative">
    <div class="position-relative d-flex">
      <input
          ref="selectionInput"
          type="text"
          class="form-control wfh-input-border wfh-input-text wfh-input-padding"
          @focusin="selecting = true"
          @keydown.esc="stopSelecting"
          @keyup="searchItem"
          v-model="value"
          autocomplete="off"
          :required="required"
      />
      <button class="btn btn-link custom-no-padding-btn align-self-center" v-if="isSelected" type="button"
              @click="resetValue">
        <i class="fa fa-times-circle"></i>
      </button>
    </div>
    <div class="position-absolute wfh-custom-selector" v-if="selecting">
      <div v-if="managingItem">
        <ManageItem
            :title="title"
            v-on:returnToSelectList="returnToSelectList"
            v-on:updateItem="updateItem"
            v-on:deleteItem="deleteItem"
            :item="selectedItem"
        />
      </div>
      <div v-else>
        <div>
          <SelectorItem
              v-for="item in filteredOptions"
              :selectorText="item.name"
              :selected="item.name === value"
              :key="item.id"
              :itemId="item.id"
              @selectItem="selectItem(item.name, item.id)"
              @manageItem="manageItem(item.id)"
          />
        </div>
        <div class="d-flex justify-content-center py-2">
          <button
              class="btn btn-outline-dark"
              style="padding: 8px 15px !important;"
              @click="managingItem = true"
          >
            {{ createBtnText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectorItem from './SelectorItem';
import ManageItem from './ManageItem';

export default {
  name: 'Selector',
  components: { ManageItem, SelectorItem },

  props: ['options', 'selected', 'title', 'required'],

  data () {
    return {
      filteredOptions: this.options.splice(),
      selecting: false,
      managingItem: false,
      itemId: null,
      value: '',
      searchText: '',
      isSelected: false,
    };
  },

  watch: {
    selected () {
      const selection = this.filteredOptions.filter(item => {
        return item.id === this.selected;
      });

      this.value = selection[0].name;
      this.isSelected = selection.length > 0;
    },

    options () {
      this.filteredOptions = this.options;
    },
  },

  computed: {
    createBtnText () {
      return (this.filteredOptions.length > 0 || this.options.length === 0)
          ? `Create a new ${this.selectorTitle}`
          :
          `Create a "${this.searchText}" ${this.selectorTitle}`;
    },

    selectedItem () {
      const itemId = this.itemId;

      if (itemId == null && this.filteredOptions.length > 0) {
        return '';
      }

      return itemId !== null ?
          this.filteredOptions.filter(item => {return item.id === this.itemId;})[0]
          : (this.searchText ? this.searchText : '');
    },

    selectorTitle () {
      return this.title ?? 'label';
    },
  },

  methods: {
    stopSelecting (e) {
      e.preventDefault();

      this.selecting = false;
      this.$nextTick(() => {
        this.$refs['selectionInput'].blur();
      });
    },

    returnToSelectList () {
      this.itemId = null;
      this.managingItem = false;
    },

    selectItem (val, id) {
      this.value = val;
      this.$emit('selectItem', val, id);
      this.selecting = false;
    },

    manageItem (itemId) {
      this.itemId = itemId;
      this.managingItem = true;
    },

    updateItem (val, itemId) {
      this.$emit('updateLabel', val, itemId);
    },

    deleteItem (itemId) {
      this.$emit('deleteItem', itemId);
      this.itemId = null;
      this.managingItem = false;
    },

    searchItem (e) {
      this.searchText = e.target.value;

      this.filteredOptions = this.options.filter(item => {
        const optionText = item.name.toLowerCase();
        return optionText.includes(this.searchText.toLocaleLowerCase());
      });
    },

    resetValue () {
      this.$emit('resetValue');
      this.value = '';
      this.searchText = '';
      this.filteredOptions = this.options.splice();
    },
  },
};
</script>

<style scoped lang="scss">
.custom-no-padding-btn {
  padding: 0 !important;
  color: #000 !important;
  position: absolute;
  right: 8px;
}

.wfh-custom-selector {
  width: 100%;
  background: #fff;
  z-index: 999;
  border: 1px solid #eff1f5;
  padding: 8px 0;
  border-radius: 0 0 8px 8px !important;
  color: #495057;
  outline: 0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
}

.wfh-custom-selector-input {
  border-radius: 0 !important;
  border: 1px solid #eff1f5;
  box-shadow: none !important;
}
</style>
